module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="accountBar__logInButton"><i class="icon icon-i16_ava"></i> <span>Войти в Личный кабинет</span></div>';
}
return __p;
};
